//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
import _ from 'underscore';

import { StreamActionType } from '@streams/actions/streamCreationActions';
import { STREAM_CREATION_ACTIONS } from '@streams/constants/streamCreationActionConstants';
import { INSTAGRAM_STREAM_SOURCE_NETWORK } from '@streams/constants/streamCreationConstants';
import { IStreamCreationState } from '@streams/models/streamCreationState';

const initialState: IStreamCreationState = {
  errors: {
    createStreamError: undefined,
    streamNameError: undefined,
    sourceError: undefined,
    exclusionSourceError: undefined,
    sourceTypeError: undefined,
    exclusionSourceTypeError: undefined,
  },
  existingStream: undefined,
  hasOutstandingSaveRequest: false,
  isLoadingSources: true,
  sourceSelector: {
    sourceLabel: '',
    sourceNetwork: INSTAGRAM_STREAM_SOURCE_NETWORK,
    sourceType: undefined,
    sourceValue: '',
  },
  sourcesAdded: [],
  exclusionSourceSelector: {
    sourceLabel: '',
    sourceNetwork: INSTAGRAM_STREAM_SOURCE_NETWORK,
    sourceType: undefined,
    sourceValue: '',
  },
  exclusionSourcesAdded: [],
  streamName: undefined,
};

export default function StreamCreationDataReducer(
  state: IStreamCreationState = initialState,
  action: StreamActionType,
) {
  switch (action.type) {
    case STREAM_CREATION_ACTIONS.ADD_SELECTED_SOURCE:
      const newSource = {
        sourceNetwork: INSTAGRAM_STREAM_SOURCE_NETWORK,
        sourceLabel: action.sourceLabel,
        sourceType: action.sourceType,
        sourceValue: action.sourceValue,
      };

      return {
        ...state,
        sourceSelector: {
          ...state.sourceSelector,
          sourceValue: '',
        },
        sourcesAdded: [...state.sourcesAdded, newSource],
      };
    case STREAM_CREATION_ACTIONS.REMOVE_SELECTED_SOURCE:
      return {
        ...state,
        sourcesAdded: _(state.sourcesAdded).without(action.source),
      };
    case STREAM_CREATION_ACTIONS.CHANGE_STREAM_NAME:
      return {
        ...state,
        streamName: action.streamName,
      };
    case STREAM_CREATION_ACTIONS.CHANGE_SOURCE_TYPE:
      return {
        ...state,
        sourceSelector: {
          ...state.sourceSelector,
          sourceType: action.sourceType,
        },
      };

    case STREAM_CREATION_ACTIONS.CHANGE_EXCLUSION_SOURCE_TYPE:
      return {
        ...state,
        exclusionSourceSelector: {
          ...state.exclusionSourceSelector,
          sourceType: action.sourceType,
        },
      };
    case STREAM_CREATION_ACTIONS.CHANGE_SOURCE_VALUE:
      return {
        ...state,
        sourceSelector: {
          ...state.sourceSelector,
          sourceValue: action.sourceValue,
        },
      };
    case STREAM_CREATION_ACTIONS.SET_SELECTED_EXCLUDED_SOURCES:
      return {
        ...state,
        exclusionSourcesAdded: action.exclusionSources,
      };
    case STREAM_CREATION_ACTIONS.ADD_EXCLUSION_SOURCE:
      const newExclusionSource = {
        sourceNetwork: INSTAGRAM_STREAM_SOURCE_NETWORK,
        sourceLabel: action.sourceLabel,
        sourceType: action.sourceType,
        sourceValue: action.sourceValue,
      };

      return {
        ...state,
        exclusionSourceSelector: {
          ...state.exclusionSourceSelector,
          sourceValue: '',
        },
        exclusionSourcesAdded: [
          ...state.exclusionSourcesAdded,
          newExclusionSource,
        ],
      };
    case STREAM_CREATION_ACTIONS.REMOVE_EXCLUSION_SOURCE:
      return {
        ...state,
        exclusionSourcesAdded: _(state.exclusionSourcesAdded).without(
          action.exclusionSource,
        ),
      };
    case STREAM_CREATION_ACTIONS.CHANGE_EXCLUSION_SOURCE_VALUE:
      return {
        ...state,
        exclusionSourceSelector: {
          ...state.exclusionSourceSelector,
          sourceValue: action.sourceValue,
        },
      };
    case STREAM_CREATION_ACTIONS.SET_EXCLUSION_SOURCE_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          exclusionSourceError: action.exclusionSourceError,
        },
      };
    case STREAM_CREATION_ACTIONS.SET_EXCLUSION_SOURCE_TYPE_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          exclusionSourceTypeError: action.exclusionSourceTypeError,
        },
      };
    case STREAM_CREATION_ACTIONS.SET_EXISTING_STREAM:
      return {
        ...state,
        existingStream: action.existingStream,
      };
    case STREAM_CREATION_ACTIONS.SET_IS_LOADING_SOURCES:
      return {
        ...state,
        isLoadingSources: action.isLoadingSources,
      };
    case STREAM_CREATION_ACTIONS.SET_OUTSTANDING_SAVE_REQUEST:
      return {
        ...state,
        hasOutstandingSaveRequest: action.hasOutstandingSaveRequest,
      };
    case STREAM_CREATION_ACTIONS.SET_SELECTED_SOURCES:
      return {
        ...state,
        sourcesAdded: action.sources,
      };
    case STREAM_CREATION_ACTIONS.SET_CREATE_STREAM_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          createStreamError: action.createStreamError,
        },
      };
    case STREAM_CREATION_ACTIONS.SET_SOURCE_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          sourceError: action.sourceError,
        },
      };
    case STREAM_CREATION_ACTIONS.SET_SOURCE_TYPE_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          sourceTypeError: action.sourceTypeError,
        },
      };
    case STREAM_CREATION_ACTIONS.SET_STREAM_NAME_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          streamNameError: action.streamNameError,
        },
      };
    case STREAM_CREATION_ACTIONS.CLEAR_STATE:
      return initialState;
    default:
      return state;
  }
}
